import { IslandComponent } from '@island-runtime/types';

/**
 * `data-react-island="PayAsYouGoPopup"` — renders nothing. The host includes it
 * from `popups_list.html.twig` (edusson `react_pay_as_you_go_popup.html.twig`)
 * on pages without the SPA, so that the island root
 * (`island-runtime/IslandRoot.tsx`, which renders `Popups`) exists there:
 * `usePopupAutoOpen` opens the popup for a `?open_popup_pay_as_you_go=1` link,
 * after the login for a guest.
 *
 * It takes no `data-props`.
 */
const PayAsYouGoPopupIsland: IslandComponent = () => null;

export default PayAsYouGoPopupIsland;
